import { render, staticRenderFns } from "./TouchpointOverviewIconCircle.vue?vue&type=template&id=b74c97ec&scoped=true&"
import script from "./TouchpointOverviewIconCircle.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverviewIconCircle.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointOverviewIconCircle.vue?vue&type=style&index=0&id=b74c97ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74c97ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b74c97ec')) {
      api.createRecord('b74c97ec', component.options)
    } else {
      api.reload('b74c97ec', component.options)
    }
    module.hot.accept("./TouchpointOverviewIconCircle.vue?vue&type=template&id=b74c97ec&scoped=true&", function () {
      api.rerender('b74c97ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointOverviewIconCircle.vue"
export default component.exports